import React from 'react';
import { CheckCircle2, TrendingUp, Clock, Smile } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    icon: <CheckCircle2 className="w-8 h-8 text-gold-500" data-id="element-463" />,
    title: 'Cierras una tarea importante al día',
    description: 'Aunque estés saturado, siempre hay progreso visible.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-gold-500" data-id="element-464" />,
    title: 'Reduces multitarea y recuperas foco',
    description: 'Un bloque protegido = trabajo real completado.'
  }, {
    icon: <Clock className="w-8 h-8 text-gold-500" data-id="element-465" />,
    title: 'Conviertes caos en plan visible',
    description: 'Sabes exactamente qué hacer y cuándo hacerlo.'
  }, {
    icon: <Smile className="w-8 h-8 text-gold-500" data-id="element-466" />,
    title: 'Terminas el día con mente liviana',
    description: 'Porque hubo cierre. No cansancio, sino logro.'
  }];
  return <section className="py-24 bg-dark-900 relative" data-id="element-467">
      <div className="max-w-7xl mx-auto px-4" data-id="element-468">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-469">
          {/* Results List */}
          <div data-id="element-470">
            <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-471">
              <span className="text-white" data-id="element-472">¿Qué vas a lograr con </span>
              <span className="text-gradient-gold font-serif italic" data-id="element-473">
                este sistema?
              </span>
            </h2>
            <p className="text-gray-400 text-lg mb-8" data-id="element-474">
              Sin promesas mágicas. Solo resultados operativos, reales,
              medibles:
            </p>

            <div className="space-y-6" data-id="element-475">
              {results.map((result, index) => <div key={index} className="flex gap-4 items-start group" data-id="element-476">
                  <div className="w-12 h-12 bg-dark-800 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 border border-white/10" data-id="element-477">
                    {result.icon}
                  </div>
                  <div data-id="element-478">
                    <h3 className="text-lg font-bold text-white mb-2" data-id="element-479">
                      {result.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-480">{result.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Success Image - Image 5 */}
          <div className="relative" data-id="element-481">
            <div className="relative rounded-2xl overflow-hidden border border-gold-500/20 shadow-2xl" data-id="element-482">
              <img src="https://cdn.magicpatterns.com/uploads/bekzQkt4e9N6mRnPmxndcf/5_Focused_morning_work_session.png" alt="Profesional exitoso con el Método CIERRE 90" className="w-full h-auto" data-id="element-483" />
            </div>

            {/* Floating stat badge */}
            <div className="absolute -bottom-6 -left-6 bg-gold-500 text-black p-6 rounded-xl shadow-2xl transform rotate-[-3deg]" data-id="element-484">
              <p className="text-4xl font-bold mb-1" data-id="element-485">90'</p>
              <p className="text-sm font-medium" data-id="element-486">
                Un bloque que
                <br data-id="element-487" />
                cambia tu día
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}